export default __webpack_public_path__ + "static/media/home_02_inactive.a086ca3f.png";